import EpisodePartsFooter from './EpisodePartsFooter';

export default EpisodePartsFooter;
